import React, { useState } from 'react';
import SideNav from './sidenav';
import InnerBanner from './innerBanner';
import { ReactComponent as ArrowSvg } from '../../../assets/images/arrow/icon_arrow_down.svg';
import { NavLink } from 'react-router-dom';
const API = ({ path, handleSearch, submitSearch, content, para, title }) => {
    const [innerWidth] = useState(window.innerWidth);
    return (
        <div className='api-pg'>
            <InnerBanner
                banner_info={ para }
                banner_title={ title }
            />
            {/* inner-banner section end */ }
            <div className="api-wrap" id="apiWrap">
                {
                    innerWidth < 1200 &&
                    <div className="mobilesidenav" id="mobilesidenav">
                        <div className="inner-box">
                            <SideNav
                                topId="apiWrap"
                                currentPath={ '' }
                                expandIcon={ <ArrowSvg /> }
                                isFixed={ true } />
                        </div>
                    </div>

                }
                <div className="container">
                    <div className="row-wrap mx-0 sticky-parent">
                        <div>
                            <SideNav
                                currentPath={ path }
                                expandIcon={ <ArrowSvg /> }
                            />
                        </div>

                        <div className="nav-content content-box">
                            <div className="searchfill-box">
                                <div className="groupinput-box">
                                    <input type="text" name="search" id="" placeholder='Search documentation' onChange={ (e) => handleSearch(e.target.value) } />
                                    <button className='search-button' type="button" onClick={ submitSearch }  ><img src={`${process.env.PUBLIC_URL}/images/icon_search.svg`} alt="search icon"/></button>
                                </div>
                            </div>
                            <div className="api-three-column">
                                <div className="row-wrap">
                                    {
                                        !!content.api_options.length && content.api_options.map((obj, index) => {
                                            return (
                                                <div className="box-12 box-md-4 item-box" key={ index }>
                                                    <div className="card">
                                                        <div className="inner-box">
                                                            <ul>
                                                                {   
                                                                    <NavLink to={ obj.api_link.url }>{ obj.api_link.title }</NavLink>
                                                                }
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default API;